import { render, staticRenderFns } from "./panel-contact.vue?vue&type=template&id=37f5e336&scoped=true&"
import script from "./panel-contact.vue?vue&type=script&lang=js&"
export * from "./panel-contact.vue?vue&type=script&lang=js&"
import style0 from "./panel-contact.vue?vue&type=style&index=0&id=37f5e336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5e336",
  null
  
)

export default component.exports